var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{attrs:{"active":_vm.$store.state.ui.progressBar.visibility,"indeterminate":_vm.$store.state.ui.progressBar.animating,"absolute":"","top":"","aria-label":"Loading progress"}})
}
var staticRenderFns = []

export { render, staticRenderFns }